import useTextInputValidation from '@/components/molecules/TextInputField/useTextInputValidation-hook';

/**
 * Centralized validation configurations for Rewards module
 * This file contains all validation rules used across Reward components
 */

// Basic form field validations
export const useNameValidation = () => {
  return useTextInputValidation('Name*', [
    {type: 'required', msg: 'is required'},
    {type: 'minLength', limit: 2, msg: 'must be at least 2 characters'},
    {type: 'maxLength', limit: 100, msg: 'must not exceed 100 characters'},
    {type: 'noSpecialChar', msg: 'cannot contain special characters'}
  ]);
};

export const usePointsValidation = () => {
  return useTextInputValidation('Points', [
    {type: 'required', msg: 'is required'},
    {type: 'number', msg: 'must be a valid number'},
    {type: 'pattern', regex: '^[1-9]\\d*$', msg: 'must be a positive integer'}
  ]);
};

export const useOrderQuantityValidation = () => {
  return useTextInputValidation('Order Quantity', [
    {type: 'required', msg: 'is required'},
    {type: 'number', msg: 'must be a valid number'},
    {
      type: 'pattern',
      regex: '^(?!0+$)0*[1-9]\\d*$',
      msg: 'must be a positive integer'
    }
  ]);
};

export const useBonusProductLimitValidation = () => {
  return useTextInputValidation('Bonus Product Limit', [
    {type: 'required', msg: 'is required'},
    {type: 'number', msg: 'must be a valid number'},
    {
      type: 'pattern',
      regex: '^(?!0+$)0*[1-9]\\d*$',
      msg: 'must be a positive integer'
    }
  ]);
};

//Visa card validation
export const useRedeemPointsValidation = () => {
  return useTextInputValidation('Redeem Points', [
    {type: 'required', msg: 'is required'},
    {type: 'number', msg: 'must be a valid number'},
    {
      type: 'pattern',
      regex: '^(?!0+$)0*[1-9]\\d*$',
      msg: 'must be a positive integer'
    }
  ]);
};

export const useRewardCashAmountValidation = () => {
  return useTextInputValidation('Reward Cash Amount', [
    {type: 'required', msg: 'is required'},
    {type: 'number', msg: 'must be a valid number'},
    {
      type: 'pattern',
      regex: '^(?!0+$)0*[1-9]\\d*$',
      msg: 'must be a positive integer'
    }
  ]);
};

export const useRewardCardTypeValidation = () => {
  return useTextInputValidation('Card Type', [
    {type: 'required', msg: 'is required'}
  ]);
};

// Cash/Discount/PepVoucher Discount validation
export const useValueValidation = () => {
  return useTextInputValidation('Value', [
    {type: 'required', msg: 'is required'},
    {type: 'number', msg: 'must be a valid number'},
    {
      type: 'pattern',
      regex: '^(?!0+$)0*[1-9]\\d*$',
      msg: 'must be a positive integer'
    }
  ]);
};

// Digital validation
export const useDigitalValueValidation = () => {
  return useTextInputValidation('Digital Value', [
    {type: 'required', msg: 'is required'},
    {type: 'number', msg: 'must be a valid number'},
    {
      type: 'pattern',
      regex: '^(?!0+$)0*[1-9]\\d*$',
      msg: 'must be a positive integer'
    }
  ]);
};

// Cash/Physical/Product validation
export const useQuotaValidation = () => {
  return useTextInputValidation('Quota', [
    {type: 'required', msg: 'is required'},
    {type: 'number', msg: 'must be a valid number'},
    {
      type: 'pattern',
      regex: '^(?!0+$)0*[1-9]\\d*$',
      msg: 'must be a positive integer'
    }
  ]);
};

export const useMaxQtyPerOrderValidation = () => {
  return useTextInputValidation('Max Quantity per Order', [
    {type: 'required', msg: 'is required'},
    {type: 'number', msg: 'must be a valid number'},
    {
      type: 'pattern',
      regex: '^(?!0+$)0*[1-9]\\d*$',
      msg: 'must be a positive integer'
    }
  ]);
};

export const useQuotaDigitalCardValidation = () => {
  return useTextInputValidation('Quota Digital Card', [
    {type: 'required', msg: 'is required'},
    {type: 'number', msg: 'must be a valid number'},
    {
      type: 'pattern',
      regex: '^(?!0+$)0*[1-9]\\d*$',
      msg: 'must be a positive integer'
    }
  ]);
};

export const useQuotaPhysicalCardValidation = () => {
  return useTextInputValidation('Quota Physical Card', [
    {type: 'required', msg: 'is required'},
    {type: 'number', msg: 'must be a valid number'},
    {
      type: 'pattern',
      regex: '^(?!0+$)0*[1-9]\\d*$',
      msg: 'must be a positive integer'
    }
  ]);
};

// Loyalty URL validation
export const useLoyaltyURLValidation = () => {
  return useTextInputValidation('Loyalty URL', [
    {type: 'required', msg: 'is required'},
    {type: 'pattern', regex: '^https?:\\/\\/.+', msg: 'must be a valid URL'}
  ]);
};

export const useLimitPerStoreValidation = () => {
  return useTextInputValidation('Limit per Store', [
    {type: 'number', msg: 'must be a valid number'},
    {
      type: 'pattern',
      regex: '^(?!0+$)0*[1-9]\\d*$',
      msg: 'must be a positive integer'
    }
  ]);
};

export const useLimitPerStoreDigitalCardValidation = () => {
  return useTextInputValidation('Limit per Store - Digital Card', [
    {type: 'number', msg: 'must be a valid number'},
    {
      type: 'pattern',
      regex: '^(?!0+$)0*[1-9]\\d*$',
      msg: 'must be a positive integer'
    }
  ]);
};

export const useLimitPerStorePhysicalCardValidation = () => {
  return useTextInputValidation('Limit per Store - Physical Card', [
    {type: 'number', msg: 'must be a valid number'},
    {
      type: 'pattern',
      regex: '^(?!0+$)0*[1-9]\\d*$',
      msg: 'must be a positive integer'
    }
  ]);
};

export const useDigitalSupplierValidation = () => {
  return useTextInputValidation('Digital Supplier', [
    {type: 'required', msg: 'is required'}
  ]);
};

// Product details validations
export const useProductQuotaValidation = () => {
  return useTextInputValidation('Product Quota', [
    {type: 'required', msg: 'is required'},
    {type: 'number', msg: 'must be a valid number'},
    {type: 'pattern', regex: '^[1-9]\\d*$', msg: 'must be a positive integer'}
  ]);
};

// Helper function for inventory validation
const validateInventoryValue = (value) => {
  const trimmedValue = String(value).trim();
  const isUnlimited = trimmedValue.toLowerCase() === 'unlimited';
  const isValidInteger = /^[1-9]\d*$/.test(trimmedValue);

  return isUnlimited || isValidInteger
    ? undefined
    : 'Inventory must be a positive integer or "Unlimited"';
};

export const useProductInventoryValidation = () => {
  return useTextInputValidation('Product Inventory', [
    {type: 'custom', validate: validateInventoryValue}
  ]);
};

// Modal-specific validations (for ProductDetailsModal and BulkProductDetailsModal)
// These are aliases to the main validation functions to maintain consistency
export const useModalPointsValidation = usePointsValidation;
export const useModalQuotaValidation = useProductQuotaValidation;
export const useModalInventoryValidation = useProductInventoryValidation;

/**
 * Validation helper functions
 */

// Helper functions for product details validation

// Helper functions for fetched products validation
const hasValidFetchedProductsArray = (fetchedProducts) =>
  Boolean(
    fetchedProducts &&
    Array.isArray(fetchedProducts) &&
    fetchedProducts.length > 0
  );

const hasValidFetchedProductDetails = (product) => Boolean(product?.details);

const hasValidFetchedPoints = (details) =>
  Boolean(details.points && details.points !== '');

const hasValidFetchedInventory = (details) =>
  Boolean(details.inventory && details.inventory !== '');

const hasValidFetchedQuota = (details) => {
  const hasQuota = Boolean(details.quota);
  const isUnlimited = details.quota?.unlimited;
  const hasQuotaValue = Boolean(
    details.quota?.value && details.quota.value !== ''
  );

  return hasQuota && (isUnlimited || hasQuotaValue);
};

const isFetchedProductValid = (product) => {
  const {details} = product;
  return (
    hasValidFetchedProductDetails(product) &&
    hasValidFetchedPoints(details) &&
    hasValidFetchedInventory(details) &&
    hasValidFetchedQuota(details)
  );
};

// Validate fetched products details for step 1 validation
export const validateFetchedProductsDetails = (fetchedProducts) => {
  return (
    !hasValidFetchedProductsArray(fetchedProducts) ||
    fetchedProducts.every(isFetchedProductValid)
  );
};
